import React from "react";
import { GoBackIcon, InfoIcon, TagClose } from "../Icons/icons.component";
import ConceptLogo from "../../assets/images/conceptbiu-logo.png";

const AddEntity = () => {
  return (
    <>
      <div className="mainContainer topicsContainer">
        <div className="dashboardHeader dashboardDetailsHeader">
          <div className="dashboardHeaderTop d-flex">
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap d-flex align-items-center">
                <span className="btnGoBack clickable">
                  <GoBackIcon />
                </span>
                <h1>Hyundai</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="topicsMiddleSection">
          <div className="topicsWrap">
            <div className="accordion accordionListWrap topicsAccordionWrap">
              <div className="customAccordionRow card active">
                <div className="card-header show">
                  <button type="button" className="btn btn-link">
                    Keywords <InfoIcon />
                  </button>
                </div>
                <div className="collapse show">
                  <div className="card-body">
                    <div className="keywordSection">
                      <div className="keywordRow">
                        <label>
                          <span>“Contains”</span> any of the keyword below
                        </label>
                        <div className="keywordTagWrap">
                          <div className="tagsWrap">
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Marketing</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Nexon EV</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">New Suv</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Tata Motors</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Best Cars</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Mileage</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Cargo</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="keywordRow">
                        <label>
                          <span>“And Contain”</span> one or more of the keywords
                          below
                        </label>
                        <div className="keywordTagWrap">
                          <div className="tagsWrap">
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Marketing</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Nexon EV</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">New Suv</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Tata Motors</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Best Cars</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Mileage</span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">Cargo</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="keywordRow">
                        <label>
                          <span>“Does Not Contain”</span> any of the keywords
                          below
                        </label>
                        <div className="keywordTagWrap">
                            No keywords added
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="entityTagWrap">
                <label>Entity Tag</label>
                <div className="entityTagOptions">
                    <label className="inputWrap">
                      Client
                      <input type="radio" checked="checked" />
                      <span className="checkmark"></span>
                    </label>
                    <label className="inputWrap">
                      Competitor
                      <input type="radio" checked="" />
                      <span className="checkmark"></span>
                    </label>
                    <label className="inputWrap">
                      Industry
                      <input type="radio" checked="" />
                      <span className="checkmark"></span>
                    </label>
                </div>
            </div>

            <div className="accordion accordionListWrap topicsAccordionWrap">
              <div className="customAccordionRow card active">
                <div className="card-header show">
                  <button type="button" className="btn btn-link">
                    Instagram Hashtags
                  </button>
                </div>
                <div className="collapse show">
                  <div className="card-body">
                    <div className="hashTagSection">
                      <div className="hashTagRow">
                        <label>
                          Add <span>“#”Hashtags</span> to fetch results from Instagram
                        </label>
                        <div className="hashTagWrap">
                          <textarea className="form-control" />
                        </div>
                      </div>
                      <div className="hashTagRow">
                        <label>
                          You have 10 <span>“#”Hashtags</span> remaining  
                        </label>
                        <div className="hashTagWrap">
                          <div className="tagsWrap">
                            <span className="tagBlockWrap">
                              <span className="tagBlock">#Marketing <span className="tagClose"><TagClose/></span></span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">#Nexon EV <span className="tagClose"><TagClose/></span></span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">#New Suv <span className="tagClose"><TagClose/></span></span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">#Tata Motors <span className="tagClose"><TagClose/></span></span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">#Best Cars <span className="tagClose"><TagClose/></span></span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">#Mileage <span className="tagClose"><TagClose/></span></span>
                            </span>
                            <span className="tagBlockWrap">
                              <span className="tagBlock">#Cargo <span className="tagClose"><TagClose/></span></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="customAccordionRow card active">
                <div className="card-header show">
                  <button type="button" className="btn btn-link">
                    Authorize Account
                  </button>
                </div>
                <div className="collapse show">
                  <div className="card-body">
                    <div className="authorizeSection">
                      <p>You can Authorize more accounts from here</p>
                      <button className="btn authorizeBtn">Authorize Facebook / Instagram Account</button>
                      <ul className="authorizeListing">
                        <li>
                          <span className="authImg">
                            <img src={ConceptLogo} />  
                          </span>
                          <div className="authInfo">
                            <div className="authName">Hyundai Verna 2020</div>
                            <div className="authType">Facebook</div>
                          </div>
                        </li>
                        <li>
                          <span className="authImg">
                            <img src={ConceptLogo} />  
                          </span>
                          <div className="authInfo">
                            <div className="authName">Hyundai Verna 2020</div>
                            <div className="authType">Facebook</div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="topicsAction text-right">
              <button className="btn btnBlue">Save Changes</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddEntity;
